import React from 'react';
import { Button } from '../Ui/Button';
import { DisplayServiceCard } from './ServiceCard/displayServiceCard';
import AddedFields from './addedFields';
import { FormContainer, DataContainer } from './styles';

const Preview = ({ isArabic, state, metaData, formData, actions, serviceCards }) => {
    return (
        <FormContainer style={{display: 'block', width: '40%'}}>
            {metaData.title && <div className={"d-flex flex-column align-items-center my-5"}>
                <h4 name={'title'} style={{color: '#333', margin: '0 10px 10px 10px'}}>{isArabic ? metaData.arabictitle : metaData.title}</h4>
                <p name={'description'} style={{color: '#333', margin: '10px 10px 0 10px'}}>{isArabic ? metaData.arabicdescription : metaData.description}</p>
            </div>}
            {(serviceCards && serviceCards.length !== 0) && <DisplayServiceCard isArabic={isArabic} data={serviceCards} formID={true} />}
            <AddedFields isArabic={isArabic} formData={formData} state={state} formID={true} />
            {(actions && actions.length !== 0) && <div>
                <DataContainer className="m-3 mb-8" style={{margin: '8px 0', display: 'flex', justifyContent: 'center', background: 'none'}}>
                    {actions.map(({actionName, arabicActionName}) =>
                        <Button key={actionName} style={{marginRight: 8}}>{isArabic ? arabicActionName : actionName}</Button>
                    )}
                </DataContainer>
            </div>}
        </FormContainer>
    );
};

export default Preview;